// common
export const white = '#FFFFFF';

//Primary color
export const miEdgeBlue50 = '#E1F0FB';
export const miEdgeBlue100 = '#9ED0F1';
export const miEdgeBlue200 = '#6DB8E9';
export const miEdgeBlue300 = '#2F9AE0';
export const miEdgeBlue400 = '#1F8BD2';
export const miEdgeBlue500 = '#1B79B7';
export const miEdgeBlue600 = '#17679C';
export const miEdgeBlue700 = '#135682';
export const miEdgeBlue800 = '#0F4467';
export const miEdgeBlue900 = '#0B324C';
export const miEdgeBlueA100 = '#e1f5fb';
export const miEdgeBlueA200 = '#9ee0f1';
export const miEdgeBlueA400 = '#1fadd2';
export const miEdgeBlueA700 = '#136b82';
export const miEdgeBlueEBF5FC = '#ebf5fc';

// Material-UI color obbject for miEdge blue
// export const miEdgeBlue = {
//     50: '#E1F0FB',
//     100: '#9ED0F1',
//     200: '#6DB8E9',
//     300: '#2F9AE0',
//     400: '#1F8BD2',
//     500: '#1B79B7',
//     600: '#17679C',
//     700: '#135682',
//     800: '#0F4467',
//     900: '#0B324C',
//     A100: '#e1f5fb',
//     A200: '#9ee0f1',
//     A400: '#1fadd2',
//     A700: '#136b82',
// };
export const miEdgeBlue = {
  50: '#E1F0FB',
  100: '#9ED0F1',
  200: '#6DB8E9',
  300: '#2F9AE0',
  400: '#1F8BD2',
  500: '#2777d3',
  600: '#17679C',
  700: '#135682',
  800: '#0F4467',
  900: '#0B324C',
  A100: '#e1f5fb',
  A200: '#9ee0f1',
  A400: '#1fadd2',
  A700: '#136b82',
};

//Secondary color
export const miEdgeOrange50 = '#ffffff';
export const miEdgeOrange100 = '#fff5ec';
export const miEdgeOrange200 = '#ffd8b4';
export const miEdgeOrange300 = '#ffb36c';
export const miEdgeOrange400 = '#ffa44e';
export const miEdgeOrange500 = '#ff942f';
export const miEdgeOrange600 = '#ff8410';
export const miEdgeOrange700 = '#f17500';
export const miEdgeOrange800 = '#d26600';
export const miEdgeOrange900 = '#b45700';
export const miEdgeOrangeA100 = '#ffffff';
export const miEdgeOrangeA200 = '#fff5ec';
export const miEdgeOrangeA400 = '#ffa44e';
export const miEdgeOrangeA700 = '#f17500';

// export const miEdgeOrange = {
//     50: '#ffffff',
//     100: '#fff5ec',
//     200: '#ffd8b4',
//     300: '#ffb36c',
//     400: '#ffa44e',
//     500: '#ff942f',
//     600: '#ff8410',
//     700: '#f17500',
//     800: '#d26600',
//     900: '#b45700',
//     A100: '#ffffff',
//     A200: '#fff5ec',
//     A400: '#ffa44e',
//     A700: '#f17500',
// };

export const miEdgeOrange = {
  50: '#ffffff',
  100: '#FDE5D3',
  200: '#FAC7A3',
  300: '#F8AA72',
  400: '#F58D42',
  500: '#F36F12',
  600: '#C7590A',
  700: '#964308',
  800: '#964308',
  900: '#964308',
  A100: '#ffffff',
  A200: '#fff5ec',
  A400: '#ffa44e',
  A700: '#f17500',
};

//Complimentary colors - for charts and stuff
export const miEdgePurple1 = '#AA56B2';
export const miEdgePurple2 = '#914568';
export const miEdgePurple3 = '#603B80';

export const miEdgeLightGreen1 = '#CBE34E';
export const miEdgeLightGreen2 = '#B8C200';
export const miEdgeLightGreen3 = '#6D9D00';

export const miEdgeRed1 = '#E05B5B';
export const miEdgeRed2 = '#E81F5A';
export const miEdgeRed3 = '#D40300';

export const miEdgeCompBlue1 = '#12C0FE';
export const miEdgeCompBlue2 = '#2B8AC1';
export const miEdgeCompBlue3 = '#2459A3';

export const miEdgeGreen1 = '#009271';
export const miEdgeGreen2 = '#008000';
export const miEdgeGreen3 = '#296501';

export const miEdgeBrown1 = '#BC9879';
export const miEdgeBrown2 = '#946E4D';
export const miEdgeBrown3 = '#7C4E26';

export const miEdgeYellow1 = '#FAF073';
export const miEdgeYellow2 = '#F4E742';
export const miEdgeYellow3 = '#D6C707';

//Material Design Colors
//Cyan

export const mdCyan300 = '#4DD0E1';
export const mdCyan500 = '#00BCD4';
export const mdCyan700 = '#0097A7';
export const mdCyan900 = '#006064';

// Indigo
export const mdIndigo400 = '#5C6BC0';
export const mdIndigo100 = '#C5CAE9';

//Pink

export const mdPink400 = '#ec407a';
export const mdPink500 = '#E91E63';
export const mdPink600 = '#d81b60';

//Grays
export const miEdgeLightGrey = '#eee';
export const miEdgeLightestGrey = '#efefef';
export const grey666 = '#666';
export const greyBDBDBD = '#bdbdbd';
export const grey999 = '#999';
export const greyE8E8E8 = '#e8e8e8';
export const grey9E9E9E = '#9e9e9e';

//Black
export const miEdgeBlack = 'rgba(0,0,0,0.87)';
